var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('stat-card',{attrs:{"label":"Sessions positives","loading":_vm.loading,"stat":(_vm.positiveSessions + " (" + (Math.ceil(
    (_vm.positiveSessions / _vm.results.length) * 100
  )) + "%)"),"neutral-badge":_vm.year,"color-class":"bg-green-500"}},[_c('trending-up-icon',{staticClass:"w-6 h-6 text-white"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }